import React, {useMemo, useState} from 'react'
import {Typography, withStyles} from '@material-ui/core';
import PropTypes from 'prop-types';
import GridBlock from 'components/GridBlock';
import AddButton from 'components/button/AddButton';
import Tr from 'translations/Translations';
import {newElement} from '../constants/initialValues'
import getObjectValue from 'libs/getObjectValue';
import {withRouter} from "react-router"
import Confirm from "components/popup/confirm/Confirm";
import ImporterForm from "./ImporterForm";
import {downloadImportTemplate} from "../lib/downloadImportTemplate";
import clsx from "clsx";
import UploadImportFile from "./UploadImportFile";
import {connect} from "react-redux";
import {wasEverPublished, isNationalProcedure, isEuropeProcedure} from "libs/getDemandStatus";


const style = theme => ({
    root: {}
})

function AdditionalButtons(
    {
        classes,
        id,
        formikProps,
        match,
        demandHeader
    }) {

    const demandId = match.params.id;
    const editable = getObjectValue('_editable', formikProps.values, true);
    const isPublished = useMemo(() => demandHeader ? wasEverPublished() : undefined, [demandHeader]);
    const isPublic = useMemo(() => demandHeader ? isNationalProcedure() || isEuropeProcedure() : undefined, [demandHeader]);

    const [confirmExportPopup, setConfirmExportPopup] = useState(false);
    const [downloadingInProgress, setDownloadingInProgress] = useState(false);
    const [uploadOpened, setUploadOpened] = useState(false);

    const handleAdd = () => {
        const elements = getObjectValue(id, formikProps.values);

        const lastElement = elements.reduce((prev, curr) => {
            if (prev.identity < curr.identity) return prev;
            return curr;
        }, {identity: 0});
        const nextId = lastElement.identity - 1;
        let newElementsList = [...elements];
        newElementsList.forEach((x, i) => {
                newElementsList[i]._open = false;
        });
        newElementsList = [
            ...newElementsList,
            newElement(nextId, demandId)
        ];

        formikProps.setFieldValue(id, newElementsList)

    };

    const hideDownloadingTemplate = () => {
        setDownloadingInProgress(false);
    };
    const downloadImportTemplateClick = () => {
        setConfirmExportPopup(false);
        setDownloadingInProgress(true);
        downloadImportTemplate(demandId, hideDownloadingTemplate, hideDownloadingTemplate);
    }

    const toggleUploadOpened = () => {
        setUploadOpened(uploadOpened => !uploadOpened);
    }

    return (
        <>
            <GridBlock column>
                <AddButton
                    onClick={handleAdd}
                    disabled={!editable || (isPublic && isPublished)}
                >
                    {Tr('add_part')}
                </AddButton>
                <AddButton
                    onClick={() => setConfirmExportPopup(true)}
                >
                    {Tr('export_form')}
                </AddButton>
                <AddButton
                    disabled={!editable || (isPublic && isPublished)}
                    onClick={toggleUploadOpened}
                >
                    {Tr('import_form')}
                </AddButton>
            </GridBlock>
            {
                uploadOpened &&
                <>
                    <Typography
                        className={classes.text}
                    >
                        {Tr('dealings_import_step_two_upload')}
                    </Typography>
                    <Typography
                        className={clsx(classes.text, classes.error)}
                    >
                        {Tr('dealings_import_step_two_upload_warning')}
                    </Typography>
                    <UploadImportFile id={demandId}/>
                </>
            }
            <ImporterForm downloadingInProgress={downloadingInProgress}/>
            <Confirm
                confirmText='make_sure_section_save'
                onCancel={() => setConfirmExportPopup(false)}
                onConfirm={downloadImportTemplateClick}
                open={confirmExportPopup}
                labelConfirm='export'
                labelCancel='cancel'
            />
        </>
    )
}

AdditionalButtons.propTypes = {
    classes: PropTypes.any,
}

export default connect((state) => ({
    demandHeader: state.resources.demandHeader
}), {})(withStyles(style)(withRouter(AdditionalButtons)));